export default "__VITE_ASSET__DJsjACCl__"